import { render, staticRenderFns } from "./ParamEstadoCivil.vue?vue&type=template&id=02ce36ce"
import script from "./ParamEstadoCivil.vue?vue&type=script&lang=js"
export * from "./ParamEstadoCivil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports